import React from 'react';
import {withRouter} from 'react-router-dom';

import Base from 'Components/Base/Base';
import {Label, InputField, Button} from 'Components/Partials/Form';
import {PreAuth, Alert, Link} from 'Components/Partials/Layouts';

import Auth from 'Services/Api/Auth/Auth';

class Activate extends Base {
    /**
     * @var state
     */
    state = {
        form: {
            email: '',
            password: '',
            passwordConfirmation: '',
        },

        working: false,

        alert: null,

        completed: false,
    };

    /**
     * @method handleSubmits
     * @param {Event} e
     * @return {Promise<void>}
     */
    handleSubmit = async (e) => {
        e.preventDefault();
        this.working();

        const request = await Auth.activate(
            this.props.match.params.token,
            this.state.form
        );

        if (request.status !== 200) {
            this.formErrors(request.message, request.errors);
            return;
        }

        this.setState({
            completed: true,
            working: false,
        });
    };

    /**
     * @method render
     * @return {*}
     */
    render() {
        const {form, alert, working, completed} = this.state;

        return (
            <PreAuth company={this.props.company}>
                <React.Fragment>
                    <h2
                        className="mt-6 text-3xl leading-9 font-extrabold text-gray-900"
                    >
                        Activate your account
                    </h2>

                    <div className="mt-8">
                        <div className="mt-6">
                            {completed && (
                                <div
                                    className={
                                        'bg-green-100 border-l-4 border-green-500 ' +
                                        'text-green-700 p-4'
                                    }
                                    role="alert">
                                    <p>
                                        Your account has been activated
                                    </p>
                                    <p className="font-bold">
                                        <Link
                                            to={'/login'}
                                            label={'Back to login'}
                                        />
                                    </p>
                                </div>
                            )}

                            {!completed && (
                                <form onSubmit={this.handleSubmit}>
                                    {alert !== null && (<Alert {...alert} />)}

                                    <div>
                                        <Label label="Email" htmlFor="email"/>
                                        <div className="mt-1 rounded-md shadow-sm">
                                            <InputField
                                                type="email"
                                                id="email"
                                                value={form.email}
                                                onChange={(e) => {
                                                    this.handleFormInput('email', e.target.value);
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="mt-4">
                                        <Label label="Password" htmlFor="password"/>
                                        <div className="mt-1 rounded-md shadow-sm">
                                            <InputField
                                                type="password"
                                                id="password"
                                                value={form.password}
                                                onChange={(e) => {
                                                    this.handleFormInput('password', e.target.value);
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="mt-4">
                                        <Label label="Confirm Password" htmlFor="passwordConfirmation"/>
                                        <div className="mt-1 rounded-md shadow-sm">
                                            <InputField
                                                type="password"
                                                id="passwordConfirmation"
                                                value={form.passwordConfirmation}
                                                onChange={(e) => {
                                                    this.handleFormInput('passwordConfirmation', e.target.value);
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="mt-6 flex items-center justify-end">
                                        <div className="text-sm leading-5">
                                            <Link
                                                to={'/login'}
                                                label={'Back to login'}
                                            />
                                        </div>
                                    </div>

                                    <div className="mt-6">
                    <span className="block w-full">
                      <Button
                          label="Activate"
                          working={working}
                      />
                    </span>
                                    </div>
                                </form>
                            )}
                        </div>
                    </div>
                </React.Fragment>
            </PreAuth>
        );
    }
}

export default withRouter(Activate);
